import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'

import { map, reject } from 'lodash'

import { Box, Chip, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import ToggleableSection from 'components/ToggleableSection'
import { getSegmentValue } from 'components/SegmentSelector/segment-service'
import api from 'common/api'
import { withContext } from '../Context'
import HighSchoolTypeSelector from './HighSchoolTypeSelector'

export const SegmentName = 'HighSchool'

export const HighSchoolSegmentSelector = ({ criteria = 'Must', segment, onChange, showHighSchoolType = true }) => {
  const currentValue = getSegmentValue(segment, criteria, SegmentName)
  const [options, setOptions] = useState([])
  const key = useRef(0)
  const handleSearch = (term) =>
    api
      .get(`/api/high_schools/find/${encodeURIComponent(term)}`)
      .then((items) =>
        map(items, (item) => ({
          id: item.value,
          name: item.tokens[0],
          city: item.tokens[1],
          state: item.tokens[2],
        })),
      )
      .catch(() => [])
      .then((data) => setOptions(data))
  const onSelect = (option) => onChange(criteria, SegmentName, [...currentValue, option])

  return (
    <ToggleableSection title="High School">
      <Box my={1}>
        <Autocomplete
          key={String(key.current)}
          options={options}
          onInputChange={(e, val, reason) => {
            if (reason === 'input') {
              handleSearch(val)
            } else {
              setOptions([])
            }
          }}
          onChange={(e, val, type) => {
            if (type === 'select-option') {
              const { id, name } = val
              key.current++
              onSelect({ id, name })
              setOptions([])
            }
          }}
          noOptionsText="No matches found."
          freeSolo
          clearOnBlur={false}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              autoFocus={key.current > 0}
              label="Student High School"
              variant="outlined"
            />
          )}
          renderOption={(option) => (
            <Box>
              <Typography variant="body1">{option.name}</Typography>
              <Typography
                variant="body2"
                color="textSecondary"
              >
                {[option.city, option.state].join(', ')}
              </Typography>
            </Box>
          )}
        />
        {map(currentValue, (hs) => (
          <Box
            key={hs.id}
            mt={1}
          >
            <Chip
              onDelete={() => onChange(criteria, SegmentName, reject(currentValue, { id: hs.id }))}
              label={hs.name}
            />
          </Box>
        ))}
      </Box>
      {showHighSchoolType && (
        <HighSchoolTypeSelector
          segmentName={SegmentName}
          segment={segment}
          onChange={onChange}
        />
      )}
    </ToggleableSection>
  )
}

HighSchoolSegmentSelector.propTypes = {
  criteria: PropTypes.string,
  segment: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  showHighSchoolType: PropTypes.bool,
}

export default withContext(HighSchoolSegmentSelector)
